import React, {Component} from "react";
import 'rc-slider/assets/index.css';
import Slider from "rc-slider";
import './NavBar.css'
import {Select} from "@mui/material";
import {MenuItem} from "@mui/material";
import { Snackbar } from "@mui/material";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close" 
import { Link } from "react-router-dom";

class NavBar extends Component{
    render(){
        const {level, format, changeLevel, changeFormat, open, closePopupIcon} = this.props;
        return(
            <header className="navbar">
                <div className="logo">
                <Link to = "/" >Colour Pallets</Link>
                </div>
            <div className="slider-container">
                <span>Level: {level}</span>
                <div className="slider">
                
                    <Slider defaultValue={level} min={100} max={900} step={100} onAfterChange={changeLevel}/>
                </div>
            </div>
            <div className="select-container">
                <Select  defaultValue="hex" onChange={changeFormat}>
                    <MenuItem value="hex">HEX - #ffffff</MenuItem>
                    <MenuItem value="rgb">RGB - rgb(255,255,255)</MenuItem>
                    <MenuItem value="rgba">RGBA - rgba(255,255,255,1.0)</MenuItem>

                </Select>
            </div>
            <Snackbar
            anchorOrigin={{vertical:"bottom", horizontal:"left"}}
            open = {open} 
            autoHideDuration={3000}
            message={<span id="message-id" >Format Changed to {format.toUpperCase()}</span>}
            ContentProps={{"aria-describedby":"message-id"}}
            action ={[
                <IconButton onClick={closePopupIcon} >
                    <CloseIcon />
                </IconButton>
            ]}
            onClose={closePopupIcon}
            >
        </Snackbar>
            </header>
        )
    }
}

export default NavBar;